var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWallets = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6518_70133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 10.0003H9.58333C8.435 10.0003 7.5 9.06616 7.5 7.91699V3.75033C7.5 2.60116 8.435 1.66699 9.58333 1.66699H17.9167C19.065 1.66699 20 2.60116 20 3.75033V7.91699C20 9.06616 19.065 10.0003 17.9167 10.0003ZM9.58333 2.50033C8.89417 2.50033 8.33333 3.06116 8.33333 3.75033V7.91699C8.33333 8.60616 8.89417 9.16699 9.58333 9.16699H17.9167C18.6058 9.16699 19.1667 8.60616 19.1667 7.91699V3.75033C19.1667 3.06116 18.6058 2.50033 17.9167 2.50033H9.58333Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5833 5.00033H7.91667C7.68667 5.00033 7.5 4.81366 7.5 4.58366C7.5 4.35366 7.68667 4.16699 7.91667 4.16699H19.5833C19.8133 4.16699 20 4.35366 20 4.58366C20 4.81366 19.8133 5.00033 19.5833 5.00033Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5833 18.3333H0.416667C0.186667 18.3333 0 18.1467 0 17.9167C0 17.6867 0.186667 17.5 0.416667 17.5H19.5833C19.8133 17.5 20 17.6867 20 17.9167C20 18.1467 19.8133 18.3333 19.5833 18.3333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 18.3337C17.6867 18.3337 17.5 18.147 17.5 17.917V12.0837C17.5 11.8537 17.6867 11.667 17.9167 11.667C18.1467 11.667 18.3333 11.8537 18.3333 12.0837V17.917C18.3333 18.147 18.1467 18.3337 17.9167 18.3337Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08366 18.3337C1.85366 18.3337 1.66699 18.147 1.66699 17.917V8.33366C1.66699 7.41449 2.41449 6.66699 3.33366 6.66699H5.41699C5.64699 6.66699 5.83366 6.85366 5.83366 7.08366C5.83366 7.31366 5.64699 7.50033 5.41699 7.50033H3.33366C2.87449 7.50033 2.50033 7.87366 2.50033 8.33366V17.917C2.50033 18.147 2.31366 18.3337 2.08366 18.3337Z",
    fill: "#171717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6518_70133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWallets, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wallets.fea1a369.svg";
export { ForwardRef as ReactComponent };